import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SidebarNavigationService {
  private seccionesSubject: BehaviorSubject<any>;
  public secciones$: Observable<any>;

  private seccionSeleccionadaSubject: BehaviorSubject<any>;
  public seccionSeleccionada$: Observable<any>;

  private historialUrls: string[] = [];  
  private destinosPermitidos = ["/tienda", "/restauracion", "/amigos-thyssen", "/"];

  constructor(private router: Router) {
    
    this.seccionesSubject = new BehaviorSubject([]);
    this.secciones$ = this.seccionesSubject.asObservable();

    this.seccionSeleccionadaSubject = new BehaviorSubject([]);
    this.seccionSeleccionada$ = this.seccionesSubject.asObservable();

    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.historialUrls.push(event.urlAfterRedirects); // Guarda cada URL visitada
    });
  }

  setSecciones(secciones) {
    this.seccionesSubject.next(secciones);
  }

  get secciones() {
    return this.seccionesSubject.value;
  }
  
  setSeccionSeleccionada(seccion) {
    this.seccionSeleccionadaSubject.next(seccion);
  }

  get seccionSelecionadaValue() {
    return this.seccionSeleccionadaSubject.value;
  }

  getNavigation() {
    return this.secciones$;
  }

  blockSecciones(url?) {
    this.secciones.forEach(seccion => {
      if (seccion.nombre !== 'venta') {
        seccion.disabled = true;
      }
      if (seccion.nombre !== 'auditorio' && url !== '/venta/pago') {
        seccion.disabled = false;
      }
      if (seccion.nombre !== 'venta' && url !== '/venta/pago') {
        seccion.disabled = false;
      }
    });
  }

  getSeccionByUrl(url) {
    return this.secciones.find(seccion => seccion.url === url);
  }

  unblockVentaAuditorio() {
    this.secciones.forEach(seccion => {
      if (seccion.nombre !== 'venta') {
        seccion.disabled = true;
      }
      if (seccion.nombre !== 'auditorio') {
        seccion.disabled = false;
      }
      if (seccion.nombre !== 'venta') {
        seccion.disabled = false;
      }
    });
  }

  unblockSecciones() {
    this.secciones.forEach(seccion => {
      seccion.disabled = false;
    });
  }

  getUrlAnterior(): string | null {
    return this.historialUrls.length > 1 ? this.historialUrls[this.historialUrls.length - 2] : null;
  }

  // ✅ Redirige si la URL anterior es tienda o restauración
  redirigirSiUrlAnteriorEsValida(): boolean {
    const urlActual = this.router.url;

    if (urlActual === "/") {
      return true;
    }
    const historial = this.getHistorial();
    const urlAnteriorValida = historial.slice().reverse().find(url => this.destinosPermitidos.includes(url));
  
    if (urlAnteriorValida) {
      this.router.navigate([urlAnteriorValida]);
      return true;
    }
    return false;
  }

  // ✅ Obtiene todo el historial de navegación
  getHistorial(): string[] {
    return [...this.historialUrls]; // Devuelve una copia para evitar modificaciones externas
  }
}
